import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTeamById } from '@artemis/store/teams/slice';
import {
  getIsVerifiedOnTeam,
  getTeamByIdInitialized,
} from '@artemis/store/teams/selectors';
import {
  getIsUserLoaded,
  getUserTeamDefaultTeamId,
} from '@artemis/store/user/selectors';

// Redirect user to the specified URL if they are already in a secured team with their email verified
const useRedirectUserOnVerifiedTeam = redirectUrl => {
  const [isReady, setIsReady] = useState(false);
  const dispatch = useDispatch();

  const isUserLoaded = useSelector(getIsUserLoaded);
  const defaultTeamId = useSelector(getUserTeamDefaultTeamId);
  const teamByIdInitialized = useSelector(getTeamByIdInitialized);
  const isVerifiedOnSecuredTeam = useSelector(getIsVerifiedOnTeam);

  // Fetch team details to get verification status
  useEffect(() => {
    if (defaultTeamId) {
      dispatch(loadTeamById(defaultTeamId));
    }
  }, [defaultTeamId]);

  // Redirect if user is on a verified team already
  useEffect(() => {
    if (isReady) {
      return;
    }

    // User is not on a team
    if (isUserLoaded && !defaultTeamId) {
      setIsReady(true);
      return;
    }

    // User is on a team
    if (isUserLoaded && defaultTeamId && teamByIdInitialized) {
      if (isVerifiedOnSecuredTeam) {
        window.location.assign(redirectUrl);
      } else {
        setIsReady(true);
      }
    }
  }, [
    isReady,
    isUserLoaded,
    defaultTeamId,
    teamByIdInitialized,
    isVerifiedOnSecuredTeam,
  ]);

  return { isReady };
};

export default useRedirectUserOnVerifiedTeam;
